import type { ChangelogEntry } from './changelog-types';

/** Histórico de versões do xat Ajuda (Help Center). */
export const changelogAjuda: ChangelogEntry[] = [
  {
    version: '2.0.0',
    date: '9 de junho de 2026',
    latest: true,
    sections: [
      {
        type: 'new',
        label: 'Novidades',
        count: 2,
        items: [
          {
            title: 'Changelog do xat Ajuda',
            details: [
              'Página de changelog com seletor para alternar entre o histórico do xat e do xat Ajuda.',
              'Registo das melhorias do Help Center separado das versões oficiais do chat.',
            ],
          },
          {
            title: 'Tooltips ilustrados nos peões Everypower',
            details: [
              'Cada variante de cor mostra o peão do power ou ace associado e o resultado em Everypower.',
              'Suporte a modo claro e escuro na galeria de smilies e peões.',
            ],
          },
        ],
      },
      {
        type: 'improvement',
        label: 'Melhorias',
        count: 5,
        items: [
          {
            title: 'Secção Everypower reorganizada',
            details: [
              'Layout em largura total alinhado com o resto da documentação do power.',
              'Notas de Supporter e histórico movidas para junto da galeria de peões.',
            ],
          },
          {
            title: 'Pstyle Everypower',
            details: [
              'Seletor entre temas Emerald Fx e Supernova Fx com pré-visualização animada.',
              'Diálogo de perfil mock com degradês animados no estilo xat.',
            ],
          },
          {
            title: 'Pesquisa unificada',
            details: [
              'Hero da homepage e da página de powers sugerem artigos e powers ao digitar.',
              'Dropdown de resultados com destaque para powers recentes.',
            ],
          },
          {
            title: 'Galeria de smilies e peões',
            details: [
              'Alternância entre modo claro e escuro com preferência guardada no navegador.',
              'Cópia rápida de códigos com feedback visual.',
            ],
          },
          {
            title: 'Assets locais de peões',
            details: [
              'Pré-visualizações everypawn* e peões de referência (Pink, Blueman, Gold, etc.) servidos de `/pawns`.',
            ],
          },
        ],
      },
      {
        type: 'fix',
        label: 'Correções',
        count: 2,
        items: [
          {
            title: 'Secção Smilies e Peões no Everypower',
            details: [
              'Merge correcto dos dados do CMS para não perder smilies e peões após carregar a API.',
            ],
          },
          {
            title: 'Documentação do power',
            details: [
              'Overview sem limite de largura reduzido, alinhado ao restante conteúdo da página.',
            ],
          },
        ],
      },
    ],
  },
  {
    version: '1.1.0',
    date: '15 de maio de 2026',
    sections: [
      {
        type: 'new',
        label: 'Novidades',
        count: 2,
        items: [
          {
            title: 'Painel de powers',
            details: [
              'Editor de powers no painel interno com dados em localStorage.',
              'Catálogo público integrado com o CMS local de powers.',
            ],
          },
          {
            title: 'Páginas de detalhe de power',
            details: [
              'Hero com badges de smilies e peões, secções Pstyle, relacionados e overview.',
              'Tratamento dedicado para powers especiais como Everypower.',
            ],
          },
        ],
      },
      {
        type: 'improvement',
        label: 'Melhorias',
        count: 3,
        items: [
          { title: 'Catálogo de powers com filtros por categoria e pesquisa.' },
          { title: 'Cards de power com preços em xats e dias, ícones oficiais do gs.xat.com.' },
          { title: 'Navegação da equipa com submenu dedicado no navbar.' },
        ],
      },
    ],
  },
  {
    version: '1.0.0',
    date: '1 de abril de 2026',
    sections: [
      {
        type: 'new',
        label: 'Lançamento',
        count: 4,
        items: [
          {
            title: 'xat Ajuda — Help Center v1',
            details: [
              'Homepage com hero, categorias de artigos e secção de powers em destaque.',
              'Artigos de ajuda organizados por categoria com pesquisa.',
              'Changelog público espelhando as versões oficiais do xat (wiki).',
              'Design system com Tailwind, shadcn/ui e identidade visual xat.',
            ],
          },
        ],
      },
    ],
  },
];
